import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ServicesService } from 'src/services/services.service';

@Component({
  selector: 'app-card-design',
  templateUrl: './card-design.component.html',
  styleUrls: ['./card-design.component.scss'],
  standalone: false
})
export class CardDesignComponent {
  imagefileURL: any;
  imgType: any;
  selectedCard: any;
  Card_Image_Name: any;
  type: any;
  image1: any;
  image2: any;
  image3: any;
  image4: any;
  event_id: any;

  constructor(
    private service: ServicesService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) { }

  ngOnInit() {
    this.event_id = sessionStorage.getItem('Event_ID');
    this.Get_Card(this.event_id);
  }

  previewpimage(files: any) {
    if (files.length === 0) {
      return;
    }
    this.spinner.show();
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.imgType = 'event_image';
      this.service.uploadimage(this.imagefileURL, this.imgType).subscribe((data: any) => {
        this.image1 = data['image_name'];
        this.service.setImage(this.image1);
        this.spinner.hide();
      });
    };
  }

  selectCard(card: any) {
    this.selectedCard = card;
  }

  Get_Card(event_id: any) {
    this.service.get_card(event_id).subscribe(
      (data: any) => {
        this.Card_Image_Name = data.data;
        this.selectedCard = this.Card_Image_Name[0].design_name,
          this.type = this.Card_Image_Name[0].type,
          this.image1 = this.Card_Image_Name[0].image1,
          this.image2 = this.Card_Image_Name[0].image2,
          this.image3 = this.Card_Image_Name[0].image3,
          this.image4 = this.Card_Image_Name[0].image4,
          this.service.setImage(this.Card_Image_Name[0].image1);
      }
    )
  }

  Update_Card() {
    const Card_Data = {
      design_name: this.selectedCard,
      event_id: this.event_id,
      type: this.type,
      image1: this.image1,
      image2: this.image2,
      image3: this.image3,
      image4: this.image4,
    }
    this.service.edit_icard(Card_Data).subscribe(
      () => {
        window.location.reload();
        this.toastr.success("Card Design Updated SuccessFully");

      }
    )
  }

  custom_card() {
    this.router.navigate(['/admin/Custom Card']);
  }

}
